import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {DataStateService} from '../core/services/data-state.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  public productType: string;
  public orderNo: string;
  public requestId: string;

  constructor(private state: DataStateService,
              private activatedRoute: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.productType = this.activatedRoute.snapshot.paramMap.get('productType');

    this.activatedRoute.queryParams.subscribe((params) => {
      this.orderNo = params['orderNo'];
      this.requestId = params['requestId'];
    });
  }

  public onButtonClicked() {
    this.router.navigate([this.state.homePath || '/']);
  }

}
